import useId from '../utils/useId';
import * as React from 'react';
export const ellisSvg = React.forwardRef(function ellisSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M0 0h500v500H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_ellis__a_${id_0})`,
      d: 'M0 0h500v500H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M384.354 332.874c-10.303 0-19.659-1.52-28.066-4.559-8.325-3.122-15.043-7.928-20.153-14.417-5.027-6.489-7.707-14.581-8.037-24.274l28.19-3.204c.082 8.051 2.679 14.212 7.789 18.483 5.111 4.271 11.952 6.407 20.525 6.407 8.407 0 14.795-1.437 19.164-4.312 4.451-2.875 6.676-6.983 6.676-12.323 0-3.039-1.113-5.502-3.338-7.392-2.226-1.889-5.069-3.368-8.531-4.436-3.462-1.15-8.531-2.547-15.207-4.19l-7.666-1.848c-9.232-2.382-16.898-4.888-22.997-7.516-6.1-2.711-11.128-6.531-15.084-11.46-3.957-4.928-5.935-11.377-5.935-19.345 0-8.625 2.308-15.772 6.924-21.44 4.616-5.668 10.675-9.816 18.175-12.445 7.583-2.711 15.826-4.066 24.728-4.066 15.166 0 27.613 3.162 37.339 9.487 9.809 6.326 15.373 16.553 16.691 30.682l-27.696 4.559c-.329-7.722-2.802-13.513-7.418-17.374-4.533-3.861-10.839-5.791-18.916-5.791-6.1 0-11.21 1.191-15.332 3.573-4.121 2.382-6.182 5.874-6.182 10.474 0 3.121 1.113 5.668 3.339 7.639 2.308 1.972 5.357 3.574 9.149 4.806 3.792 1.232 8.943 2.547 15.455 3.943 11.21 2.464 20.071 4.888 26.583 7.27 6.594 2.3 12.28 6.12 17.062 11.459 4.781 5.258 7.171 12.487 7.171 21.687 0 14.129-5.152 24.316-15.455 30.558-10.222 6.243-23.203 9.365-38.947 9.365ZM198.062 153h29.622v176.629h-29.622V153Zm44.684 0h29.622v176.629h-29.622V153Zm44.684 50.537h29.623v126.092H287.43V203.537Zm0-50.537h29.623v35.526H287.43V153Zm-115.391 68.484c4.781 5.914 8.408 13.102 10.88 21.563 2.473 8.461 3.71 17.744 3.71 27.848l-.124 4.189H92.292c.494 23.494 11.21 35.241 32.146 35.241 9.149 0 16.238-1.89 21.266-5.669 5.028-3.861 8.243-9.693 9.644-17.497l29.179 2.218c-3.297 14.376-10.015 25.219-20.153 32.53-10.139 7.312-23.368 10.967-39.689 10.967-19.04 0-34.29-5.832-45.746-17.497C67.646 303.876 62 287.571 62 266.459c0-9.858 1.401-18.853 4.204-26.985 2.885-8.133 7.13-15.197 12.735-21.194 11.375-11.829 26.541-17.743 45.499-17.743 9.974 0 19.04 1.848 27.201 5.544 8.242 3.615 15.042 8.749 20.4 15.403Zm-47.601 1.602c-11.705 0-20.195 3.696-25.47 11.089-3.544 4.929-5.687 11.049-6.429 18.36h63.427a39.208 39.208 0 0 0-2.225-10.597c-1.237-3.532-2.885-6.53-4.946-8.995-2.802-3.45-6.141-5.955-10.015-7.516-3.874-1.561-8.655-2.341-14.342-2.341Z',
      fill: '#0D0C0C',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_ellis__a_${id_0}`,
          x1: 250,
          y1: 0,
          x2: 250,
          y2: 486,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.65,
          stopColor: '#fff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E3FFF6',
        }),
      ),
    ),
  );
});
ellisSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 500 500',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ellis = {
  category: 'brand',
  colorable: false,
  name: 'ellis',
  svg: ellisSvg,
};
